export default __webpack_public_path__ + "ed6532e1bd7e25189dcbeb61c7e4277d.png";